import { render, staticRenderFns } from "./sahitya.vue?vue&type=template&id=5175fc98&scoped=true"
import script from "./sahitya.vue?vue&type=script&lang=js"
export * from "./sahitya.vue?vue&type=script&lang=js"
import style0 from "./sahitya.vue?vue&type=style&index=0&id=5175fc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175fc98",
  null
  
)

export default component.exports